import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productTemplateIdZodSchema } from "@@/shared/products/templates/product-template-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const setDraftProductTemplateCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("SET_DRAFT_PRODUCT_TEMPLATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    templateId: productTemplateIdZodSchema,
});

type SetDraftProductTemplateCommand = z.infer<
    typeof setDraftProductTemplateCommandZodObject
>;
const setDraftProductTemplateCommandZodSchema: z.ZodSchema<SetDraftProductTemplateCommand> =
    setDraftProductTemplateCommandZodObject;

type FactoryParams = Except<
    SetDraftProductTemplateCommand,
    "_id" | "_type" | "_createdAt"
>;
const setDraftProductTemplateCommandFactory = (params: FactoryParams) => {
    const SetDraftProductTemplateCommand: SetDraftProductTemplateCommand = {
        ...params,
        _id: generateId({ prefix: "command__" }),
        _type: "SET_DRAFT_PRODUCT_TEMPLATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return SetDraftProductTemplateCommand;
};

export {
    setDraftProductTemplateCommandFactory,
    setDraftProductTemplateCommandZodObject,
    setDraftProductTemplateCommandZodSchema,
};
export type { SetDraftProductTemplateCommand };
